import "./setup/processPolyfill";
import './froalaSetup';
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import $ from "jquery";
import store from "./store";
import "./index.css";
import axios from "axios";
import { resolveBaseURL } from "./utils/apiClient";
import apiClient from "./utils/apiClient";
import { attachAuthInterceptor } from "./utils/setupAuthInterceptor";

// Some legacy UI libs (e.g. react-owl-carousel) expect jQuery on window at module init time.
// Load App only after wiring these globals.
if (typeof window !== "undefined") {
  window.$ = window.$ || $;
  window.jQuery = window.jQuery || $;
}

const App = require("./App").default;


// IMPORTANT: Froala/WIRIS need strict load ordering and expect a global `FroalaEditor`.
// We use `require` so we can set the global before loading plugins.
// (No need for require() block, ES imports above handle load order)

// Configure axios to send credentials (cookies) with every request
// This is required for the backend authentication to work correctly
axios.defaults.withCredentials = true;
axios.defaults.baseURL = resolveBaseURL();

// On 401, transparently call /refresh-token (HttpOnly cookie) and retry.
// Registered on both the global axios instance and the shared apiClient.
attachAuthInterceptor(axios);
attachAuthInterceptor(apiClient);



import { positions, transitions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
const options = {
  //timeout: 100000,
  timeout: 5000,
  positions: positions.MIDDLE_RIGHT,
  transitions: transitions.SCALE,
  offset: "80px",
};

const renderRoot = () => {
  ReactDOM.render(
    <Provider store={store}>
      <AlertProvider template={AlertTemplate} {...options}>
        <App />
      </AlertProvider>
    </Provider>,
    document.getElementById("root")
  );
};

renderRoot();
